import { fetcher } from '../utils'
import { ComponentUserMenuVO } from '@repo/types'

export default async (): Promise<ComponentUserMenuVO> => fetcher(`/api/user/menu`, 'GET', undefined)
